import { Panel, RoutedPanelProps } from '@/components/Layout/Panel/Panel';
import { Lock } from 'lucide-react';

/**
 * Rendered by the stack in place of a panel the current account may not
 * open (see navigation/access.ts). The real panel never mounts, so none of
 * its data queries fire.
 */
export function ForbiddenPanel({
  params,
  path,
  basePath,
  ...panelProps
}: RoutedPanelProps) {
  return (
    <Panel {...panelProps} icon={Lock} maxPanelWidth="md">
      <div
        className="text-muted-foreground flex h-full flex-col items-center justify-center gap-2 p-8
          text-center"
      >
        <Lock className="size-8" aria-hidden />
        <p className="text-foreground text-sm font-medium">
          Niet beschikbaar voor jouw account
        </p>
        <p className="text-xs">
          Dit onderdeel is niet beschikbaar voor externe accounts.
        </p>
      </div>
    </Panel>
  );
}
